import React from 'react';
import { Box, Divider, Stack } from '@mui/material';
import { styles } from './styles';
import { useQueryClient } from '@tanstack/react-query';
import AnswersView from '../ApprovalForms/ApprovalForm/AnswersView';

export default function FormResponses() {
  const queryClient = useQueryClient();
  const externalViewData = queryClient.getQueryData<any>(['externalViewData']);
  const smartForms = externalViewData?.application.smart_forms;
  return (
    <Stack sx={styles.sectionContainer}>
      <Stack sx={{ fontSize: '16px', fontWeight: 600 }}>Form Responses</Stack>
      <Stack sx={{ color: '#666666', fontWeight: 'bold' }}>Responses</Stack>
      {smartForms?.map((form: any, index: number) => {
        return (
          <Stack sx={{ rowGap: 1 }} key={form.id}>
            <Box sx={{ color: '#53B2AE', fontWeight: 'bold', fontSize: '16px' }}>{form.name}</Box>
            {form.question_and_answers.map((q) => {
              return (
                <Stack sx={{ rowGap: 1 }} key={q.id}>
                  <Stack sx={styles.formResponseAnswerView}>
                    <AnswersView answer={q} />
                  </Stack>
                </Stack>
              );
            })}
            {index !== smartForms.length - 1 && <Divider />}
          </Stack>
        );
      })}
    </Stack>
  );
}
